import React, { useRef, useState, useEffect } from 'react';
import Modal from '../../../components/Modal';
import LenderUgroService from '../../../services/lender';
import { Context } from '../../../config/store';
import { toast } from 'react-toastify';
import { useNavigate, useParams } from 'react-router';
import message from '../../../constant/message';
import Button from '../../../components/Common/Button';
import { objectsForEach } from '../../../common/objectToArray';

const ChangeStatusOTC = ({
    modelState,
    detailLenderId,
    detailLenderName,
    toggleModal,
    getLeadDetail
}) => {
    const navigate = useNavigate();
    const { state } = React.useContext(Context);
    const [otcDocs, setOtcDocs] = useState([]);
    const [comment, setComment] = useState('');
    const [loading, setLoading] = useState(false);
    const leadId = useParams()['id'];
    const textAreaRef = useRef();
    
    useEffect(()=>{
        getOTCDocuments()
    },[])

    useEffect(() => {
        textAreaRef.current?.setAttribute('style', 'height: 60px !important;');
    }, []);

    const getOTCDocuments = async () => {
        try {
            const response = await LenderUgroService.getOTCDocuments({
                type: state.userType,
				leadId: leadId,
				lenderId: detailLenderId,
            });
            let data = response?.data?.data || [];
            setOtcDocs(data);
        } catch (err) {
            let error = err?.response?.data?.messages?.error;
            // toast.error(error?.form?.[0] || error?.others?.[0] || message.ERROR_FORM);
        }
    }

    const changeOTCStatus = async () => {
        setLoading(true);
        try {
            let docIds = [];
            otcDocs.forEach(({doc_id, is_checked},i,arr)=>{
                if(is_checked){
                    docIds.push(doc_id);
                }
            })
            const response = await LenderUgroService.dpwotcChangeStatus(
                state.userType,
				leadId,
                docIds,
                comment,
            );
            // getLeadDetail();
            const success = response?.data?.messages?.success;
            toast.success(
                success?.form?.[0] || success?.others?.[0] || message.SAVED_SUCCESS
            );
            navigate('/portfolio/disbursal-pending');
        } catch (err) {
            let error = err?.response?.data?.messages?.error;
            toast.error(error?.form?.[0] || error?.others?.[0] || message.ERROR_FORM);
        }
        setLoading(false);
    };

    const headerCheckboxHandler = (e) => {
        let od = otcDocs.map(({doc_id, doc_name}) => {
            return {doc_id, doc_name, 'is_checked': e.target.checked}
        })
        setOtcDocs(od);
    }

    const checkboxHandler = (i, e) => {
        let od = [...otcDocs];
        od[i]['is_checked'] = e.target.checked;
        setOtcDocs(od);
    }

    return (
        <Modal state={modelState} closeModal={toggleModal} style={{ width: "450px" }} removeBorderSpace={true} closeOnOverlayClick={false}>
            <div className="modal-header-container">
                <div className="modal-title">Select documents to add in OTC</div>
                <div className="closeModalView" onClick={toggleModal}>
                    <span className="closeModalIcon">x</span>
                </div>
            </div>
            {otcDocs.length ?
            <div className='p-4'>
                <div>
                    <div class='form-group'>
                        <div class='row' style={{'padding-bottom': '25px'}}>
                            <div class='col-12 table-responsive' style={{ height: "300px", overflowY: "scroll", overflowX: 'clip' }}>
                                <table className='table table-striped' width='100%'>
                                    <tbody>
                                        <tr>
                                            <th style={{width: '60px'}}>
                                                <input
                                                    type='checkbox'
                                                    checked={otcDocs.every(({is_checked})=> is_checked==true)}
                                                    value={0}
                                                    onChange={e => headerCheckboxHandler(e)}
                                                />
                                            </th>
                                            <th style={{width: '338px'}}>Document Names</th>
                                        </tr>
                                        {otcDocs.map(({doc_id, doc_name, is_checked}, i)=>
                                        <tr key={doc_id}>
                                            <td style={{width: '60px'}}>
                                                <input
                                                    type='checkbox'
                                                    checked={is_checked}
                                                    id={'row-checkbox-' + i}
                                                    value={doc_id}
                                                    onChange={e => checkboxHandler(i, e)}
                                                />
                                            </td>
                                            <td style={{width: '338px'}}>{ doc_name }</td>
                                        </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div class='form-group'>
                        <label>Comments</label>
                        <div class='row'>
                            <div class='col-12'>
                                <textarea
                                    className='form-control custom-form-control'
                                    ref={textAreaRef}
                                    name='comment'
                                    value={comment}
                                    onChange={(e) => setComment(e.target.value)}
                                    >
                                </textarea>
                            </div>
                        </div>
                    </div>
                </div>
                <div class='d-flex align-items-center justify-content-center mt-3'>
                    <button type='button' onClick={changeOTCStatus} class='btn btn-custom' disabled={loading}>
                        {loading ? <div className='loader' /> : 'OK'}
                    </button>
                    <button
                        type='button'
                        class='btn btn-outline-custom ml-2'
                        data-dismiss='modal'
                        onClick={toggleModal}
                    >
                        Cancel
                    </button>
                </div>
            </div>
            :
            <div style={{"height": "100px"}}><div className='loader' /></div>
            }
        </Modal>
    );
};

export default ChangeStatusOTC;
